import { render, staticRenderFns } from "./pelepasan.vue?vue&type=template&id=3d5efc40"
import script from "./pelepasan.vue?vue&type=script&lang=js"
export * from "./pelepasan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports